import {AbstractControl} from '@angular/forms';
import * as moment from 'moment';
const momentObj = (moment as any);

export function phoneValidator(control: AbstractControl) {
  const phoneRe = /^[2-9][0-8]\d{1}[2-9](?![1]{2})\d{2}\d{4}$/;
  const internationalPhoneRe = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  if (control.value !== null && control.value !== undefined && control.value.length > 0) {
    const digits = control.value.replace(/\D/g, '');
    if (!phoneRe.test(digits) && !internationalPhoneRe.test(digits)) {
      return {
        invalidPhone: true
      };
    }
  }

  return null;
}

export function ValidateBirthdate(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const now = momentObj(momentObj.now());
  const date = momentObj(control.value, 'MM/DD/YYYY', true) as moment.Moment;

  if (date > now) {
    return {invalidDate: true};
  }

  if (date.isValid()) {
    return null;
  }

  return {invalidDate: true};
}

export function ValidateEmail(control: AbstractControl) {
  if (!control.value) {
    return null;
  }

  const valid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value);

  if (valid) {
    return null;
  }

  return {invalidEmail: true};
}
